import React from 'react';
import { Type, TextCursorInput } from 'lucide-react';
import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { FlyoutTab } from '../../editor-shell/components/flyout-tab';

export const TextButton: React.FC = () => {
  const { addText, addAutoFitText } = useEditorCanvas();

  return (
    <FlyoutTab
      panelId='text'
      label='Texto'
      icon={<Type size={18} />}
      items={[
        { label: 'Normal', icon: <Type size={18} />, onClick: addText },
        { label: 'Auto', icon: <TextCursorInput size={18} />, onClick: addAutoFitText }
      ]}
    />
  );
};
